
import { Component, Prop, Vue } from "vue-property-decorator"

// @ts-ignore
import Password from "vue-password-strength-meter"
import { ZXCVBNFeedback } from "zxcvbn"

@Component({
	components: {
		"password": Password
	}
})
export default class PasswordInput extends Vue {
	@Prop({ type: String, required: true })
	value!: string;

	@Prop({ type: Number, required: true })
	minimumLength!: number;

	@Prop({ type: String, required: true })
	labelText!: string;

	public passwordScore: number | null = null
	public passwordFeedback: ZXCVBNFeedback = {
		warning: "",
		suggestions: []
	}

	public get password () {
		return this.value
	}

	public set password (value: string) {
		this.$emit("input", value)
	}

	private updateScore (score: number) {
		this.passwordScore = score
		this.$emit("score", this.passwordScore)
	}

	private updateFeedback (feedback: ZXCVBNFeedback) {
		this.passwordFeedback = feedback
	}

	get passwordValid () {
		const valid = !(this.passwordFeedback.warning || this.passwordFeedback.suggestions.length > 0)
		this.$emit("valid", valid)
		return valid
	}

	get allSuggestions () {
		if (this.passwordFeedback.suggestions.length === 0) {
			// Hide our tooltips, so they don't stay open if user still has it hovered/active
			this.$root.$emit("bv::hide::tooltip")
			return ""
		}

		return this.passwordFeedback.suggestions.join("\n")
	}

	get warningOrSuggestions () {
		if (this.value.length < this.minimumLength) {
			return `Minimum length is ${this.minimumLength} characters`
		}

		if (this.passwordFeedback.warning) {
			return this.passwordFeedback.warning
		}

		return this.passwordFeedback.suggestions.join(". ")
	}
}
